var map = {
	"./de.png": "HHf0",
	"./en.png": "asNS",
	"./fr.png": "A3Gk",
	"./it.png": "UOyf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WV5t";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags ^\.\/.*\.png$
// module id = WV5t
// module chunks = 24